import { getPageTypes } from "@config/cms";
import { getSsrCmsPageProps } from "@utils/getSsrCmsPageProps";
import { getSsrCmsPagesProps } from "@utils/getSsrCmsPagesProps";
import { renderPage } from "@utils/renderPage";
// import { getCookie } from "cookies-next";
// import { initializeApollo, addApolloState } from "@lib/apollo";
// import { GET_ALL_PAGES } from "@api/queries/cms-new";

const type = getPageTypes().regular;

export default function RegularPage(props) {
  return renderPage(props);
}

// export async function getStaticProps({ params, ...props }) {
//   try {
//     return getSsrCmsPageProps({ ...props, type, slug: params.slug });
//   } catch (error) {
//     console.log(error);
//     return {
//       redirect: {
//         destination: "/500",
//       },
//     };
//   }
// }

// export async function getStaticPaths({ locales }) {

//   let paths = [];

//   for (const locale of locales) {
//     const data = await getSsrCmsPagesProps({ locale, type })
//     const pages = data.getAllPagesUser.filter(page => !!page.data);
//     const localePaths = pages.map(page => ({
//       params: { slug: page.data.slug },
//       locale,
//     }));

//     paths = paths.concat(localePaths);
//   }

//   return { paths, fallback: 'blocking' };
// }

export const getServerSideProps = async ({ params, ...props }) => {
  // Server errors render through _error at the original URL, not a CMS /500 page.
  if (params.slug === "500") return { notFound: true };

  // const {
  //   req,
  //   res,
  //   locales,
  //   locale,
  //   resolvedUrl,
  //   defaultLocale,
  //   query,
  //   params,
  // } = props;

  // const type = getPageTypes().regular;

  return getSsrCmsPageProps({ ...props, type, slug: params.slug });
};
